export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7969.e0b33b35.jpg";